interface HamburgerProps {
  onToggle: () => void;
}

const Hamburger = ({ onToggle }: HamburgerProps) => (
  <button
    aria-label="hamburger menu"
    className="mobile-nav__hamburger"
    data-testid="mobile-nav-hamburger"
    onClick={onToggle}
    type="button"
  >
    <span className="mobile-nav__hamburger-line" />
    <span className="mobile-nav__hamburger-line" />
    <span className="mobile-nav__hamburger-line" />
  </button>
);

export default Hamburger;
